import { render, staticRenderFns } from "./CourseTaskCheckTypeDropdown.vue?vue&type=template&id=661f3415&"
import script from "./CourseTaskCheckTypeDropdown.vue?vue&type=script&lang=ts&"
export * from "./CourseTaskCheckTypeDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports